export const state = () => ({
  currentMenu: undefined,
  currentSection: undefined,
  currentSectionList: [],
  sectionCache: [],
  parentClause: undefined,
  parentSection: undefined
});
